import React from 'react';
import { Icon } from 'ui';

const FilterToggleButton = ({ onClick, children, disabled }) => (
  <button
    type="button"
    disabled={disabled}
    onClick={onClick}
    className="NewButton NewButton--white minw-150 d-f jc-sb ai-c gap-16"
  >
    {children}
    <Icon name="caret_down" className="c-gray-dark" />
  </button>
);

export default FilterToggleButton;
